import { createApi } from '@reduxjs/toolkit/query/react';
import { oneClubFetchBase } from '~/api/baseFetch';
import {
  TOneClubGetUserTokenResponse,
  TOneClubGetUserTokenPayload,
  TOneClubGetUserProfileResponse,
  TOneClubGetUserProfilePayload,
} from '~/api/oneClub/oneclub.type';

export const oneClubApi = createApi({
  reducerPath: 'oneClubApi',
  baseQuery: oneClubFetchBase,
  endpoints: builder => ({
    getUserToken: builder.query<
      TOneClubGetUserTokenResponse,
      TOneClubGetUserTokenPayload
    >({
      query: data => ({
        url: '/signinforthirdparty',
        body: data,
      }),
    }),
    getUserProfile: builder.query<
      TOneClubGetUserProfileResponse,
      TOneClubGetUserProfilePayload
    >({
      query: data => ({
        url: '/getUserProfile',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetUserProfileQuery,
  useGetUserTokenQuery,
  useLazyGetUserProfileQuery,
  useLazyGetUserTokenQuery,
} = oneClubApi;
